<div class="row" data-cy="formulario">
	<div class="col-sm-12">
		<div class="br-card bg-gray-2">
			<form [formGroup]="form">
				<div class="card-content">
					<!-- Órgão -->
					<div class="row">
						<div class="col-sm-12 mt-2 br-input">
							<sgp-select-orgao
								[control]="$any(form.controls['orgao'])"
								[options$]="resultadoAvaliacaoService.orgaos$"
								[showError]="form.controls['orgao'].errors?.['required'] && submetido"
								(changed)="onChangeOrgao($event)"
							/>
						</div>
					</div>

					<!-- Processo Avaliativo -->
					<div class="row">
						<div class="col-sm-12 mt-2 br-input">
							<sgp-select-processo-avaliativo
								[control]="$any(form.controls['processoAvaliativo'])"
								[options$]="resultadoAvaliacaoService.processosAvaliativos$"
								[showError]="form.controls['processoAvaliativo'].errors?.['required'] && submetido"
								(changed)="onChangeProcessoAvaliativo($event)"
							/>
						</div>
					</div>

					<!-- Ciclo -->
					<div class="row">
						<div class="col-sm-12 mt-2 br-input">
							<sgp-select-ciclo
								[control]="$any(form.controls['ciclo'])"
								[options$]="resultadoAvaliacaoService.ciclos$"
								(changed)="onChangeCiclo($event)"
							/>
						</div>
					</div>
				</div>

				<div class="card-footer">
					<div class="row mt-2">
						<div class="col text-right">
							<button
								id="botao-limpar"
								pButton
								type="button"
								data-cy="botao-limpar"
								class="secondary mr-2"
								(click)="limpar()"
							>
								Limpar
							</button>
							<button
								id="botao-pesquisar"
								pButton
								type="submit"
								data-cy="botao-pesquisar"
								class="primary"
								(click)="pesquisar()"
							>
								Pesquisar
							</button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>
